// Decorativos: el nombre accesible permanece en el texto del control.
const trazos = {
  agregar: "M12 5v14M5 12h14",
  cerrar: "m6 6 12 12M6 18 18 6",
  siguiente: "M4 12h16m-6-6 6 6-6 6",
  anterior: "M20 12H4m6-6-6 6 6 6",
  desplegar: "m9 5 7 7-7 7",
  arrastrar: "M9 5h.01M15 5h.01M9 12h.01M15 12h.01M9 19h.01M15 19h.01",
  historial: "M3 11a9 9 0 1 1 2 7M3 4v7h7m2-4v5l3 2",
  ajustes: "M4 6h16M4 12h16M4 18h16M8 3v6m8 0v6m-6 0v6",
  sol: "M12 2v2m0 16v2M2 12h2m16 0h2M5 5l1.5 1.5m11 11L19 19M5 19l1.5-1.5m11-11L19 5M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0",
  luna: "M20 14A8 8 0 0 1 10 4a8 8 0 1 0 10 10Z",
  candado: "M7 10V7a5 5 0 0 1 10 0v3M5 10h14v11H5Zm7 4v3",
  usuario: "M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0M4 21v-2a8 8 0 0 1 16 0v2",
  buscar: "M16 10a6 6 0 1 1-12 0 6 6 0 0 1 12 0m-2 4 6 6",
  guardar: "M4 3h13l4 4v14H3V3Zm3 0v6h10V3M7 21v-8h10v8",
  enviar: "m3 3 19 9-19 9 4-9Zm4 9h15",
  descargar: "M12 3v12m-5-5 5 5 5-5M4 16v5h16v-5",
  archivo: "M14 3H5v18h14V8Zm0 0v5h5M8 12h8m-8 4h8",
  imagen: "M3 3h18v18H3Zm0 13 5-5 5 5 3-3 5 5M8 7h.01",
  idea: "M9 18h6m-5 3h4M8 15a7 7 0 1 1 8 0l-1 3H9Z",
  cargar: "M20 12a8 8 0 1 1-8-8",
  eliminar: "M4 7h16M10 11v6m4-6v6M6 7l1 13h10l1-13M9 7V4h6v3",
  check: "m5 12 5 5 9-10",
  alerta:
    "M12 9v4m0 4h.01M10.3 3.9 2.4 18a2 2 0 0 0 1.7 3h15.8a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z",
  info: "M12 11v6m0-10h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0",
  salir: "M15 4h4v16h-4M10 17l5-5-5-5m5 5H3",
  bajar: "m6 9 6 6 6-6",
  menu: "M4 7h16M4 12h16M4 17h16",
} as const;
export default function Icono({ nombre }: { nombre: keyof typeof trazos }) {
  return (
    <span className={`icono icono-${nombre}`} aria-hidden="true">
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
        focusable="false"
      >
        <path d={trazos[nombre]} />
      </svg>
    </span>
  );
}
